import { render } from "./DashboardDataTableAptV6.vue?vue&type=template&id=404418a6"
import script from "./DashboardDataTableAptV6.vue?vue&type=script&lang=js"
export * from "./DashboardDataTableAptV6.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__